import { getBeefTrendsBackend, updateBeefTrend, uploadTrendLogo } from '@/api/trend'

const trend = {
  state: {
    rows: [],
    total: 0
  },

  mutations: {
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_TOTAL: (state, total) => {
      state.total = total
    }
  },

  actions: {
    GetBeefTrendsBackend({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefTrendsBackend(params).then(response => {
          commit('SET_ROWS', response.Data.BackRows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateBeefTrend({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBeefTrend(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 上传公司动态logo
    UploadTrendLogo({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadTrendLogo(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default trend



// WEBPACK FOOTER //
// ./src/store/modules/trend.js